import * as React from "react";
import {css} from "/src/utils/utils";
import Image, {ImageObject} from "/src/components/image/Image";
import CTAButton, {
  formatContentfulCTA,
} from "/src/components/buttons/cta-button/CTAButton";
import * as styles from "./loop-carousel-card.module.scss";

interface Props {
  slide:
    | Queries.CarouselSlideFragmentFragment
    | Queries.JtbdCollectionFragmentFragment;
  isActive: boolean;
}

export function LoopCarouselCard(props: Props) {
  const {isActive, slide} = props;
  const caption =
    slide.__typename === "ContentfulCarouselSlide"
      ? slide.body?.body
      : undefined;
  const cta =
    slide.__typename === "ContentfulCarouselSlide" && slide.ctaButton
      ? formatContentfulCTA(slide.ctaButton)
      : undefined;

  return (
    <div
      className={css(
        styles.loopCarouselCard,
        isActive ? styles.loopCarouselCardActive : ""
      )}
    >
      {slide?.highlightedIcon && (
        <div className={styles.loopCarouselCard__icon}>
          <Image image={slide.highlightedIcon as ImageObject} />
        </div>
      )}
      <div className={styles.loopCarouselCard__title}>
        <h4 className="h4">{slide.title}</h4>
      </div>
      {caption && (
        <p className={css("p", styles.loopCarouselCard__caption)}>{caption}</p>
      )}
      {cta && (
        <div className={styles.loopCarouselCard__cta}>
          <CTAButton cta={cta} kind="tertiary" />
        </div>
      )}
    </div>
  );
}
